import {createUseStore} from '@containers/hooks'
import {SubtaskUtil} from '@extensions/subtask-util'
import {makeAutoObservable} from 'mobx'
import {DataObjectId} from 'yougile-model'
import {SetUtil} from 'yougile-util'

interface State {
  opened: Set<DataObjectId>
}

export class ParentTasksStore {
  state: State = {
    opened: new Set()
  }

  constructor(public taskId: DataObjectId, public onBoard: boolean) {
    makeAutoObservable(this)
    if (onBoard) {
      this.getParentTaskIds(taskId).forEach(id => this.toggleOpen(id))
    }
  }

  getParentTaskIds(taskId: DataObjectId): DataObjectId[] {
    const parentTaskIds = SubtaskUtil.getParentTaskIds(taskId)
    return parentTaskIds.length > 0 ? parentTaskIds : [taskId]
  }

  toggleOpen(taskId: DataObjectId): void {
    SetUtil.toggle(this.state.opened, taskId)
  }
}

const [StoreContext, useStore] = createUseStore(ParentTasksStore)
export {StoreContext, useStore}
